/*
 * @Author: your name
 * @Date: 2021-05-28 20:18:01
 * @LastEditTime: 2025-09-19 15:49:18
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\api\request.js
 */

// import axios from 'axios';
import axios from 'more-request/instance';

import VueCookies from 'vue-cookies';
import { Message } from 'element-ui';
import router from '../router/router.js';
import utils from '../utils/utils';
import store from '../store/index';
import { gateway, epecGrayGroup, secure } from './config';

axios.defaults.timeout = 50000;
axios.defaults.baseURL = `${gateway}/api`;
axios.defaults.withCredentials = true;
let record403 = false;
axios.interceptors.request.use(
  (config) => {
    const token = VueCookies.get('epecToken');
    const { companyId } = store.state.USERINFO;
    if (config.url.indexOf('/user-center/user/mallLoginOut') != -1) {
      // alert(123)
      VueCookies.remove('epecUrlToRedirectAfterLogout', {
        domain: '.epec.com',
        path: '/',
        secure,
      });
    }

    const isOssurl = config.url.indexOf('.json') != -1;
    if (token && !isOssurl) {
      if (companyId) {
        config.headers = {
          'Content-Type': 'application/json',
          'epec-sso-token': token,
          'epec-from': 'CORP_WEB_SITE',
          // 'epec-from': 'PURCHASE_WEB_SITE',
          'epec-locale': 'ZH',
          'epec-company-id': companyId,
        };
      } else {
        config.headers = {
          'Content-Type': 'application/json',
          'epec-sso-token': token,
          'epec-from': 'CORP_WEB_SITE',
          // 'epec-from': 'PURCHASE_WEB_SITE',
          'epec-locale': 'ZH',
        };
      }
    } else {
      // axios.defaults.withCredentials = false;
      config.headers = {
        'Content-Type': 'application/json',
      };
    }
    if (process.env.NODE_ENV !== 'production') {
      VueCookies.set(
        'epec-gray-group',
        epecGrayGroup,
        null,
        '/',
        '.epec.com',
        secure
      );
      config.headers['epec-gray-group'] = epecGrayGroup;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
); // 响应拦截器即异常处理
axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.freshToken) {
      VueCookies.set(
        'epecToken',
        response.data.freshToken,
        null,
        '/',
        '.epec.com',
        secure
      );
      const seconds =
        new Date().getTime() + response.data.freshTokenMaxAgeToAdd * 1000;
      VueCookies.set(
        'epecTokenExpiredTime',
        seconds,
        null,
        '/',
        '.epec.com',
        secure
      );
    }

    // 份额控制 10秒提示
    const urlArr = [
      '/purchase/purchaseShare/add',
      '/purchase/purchaseShare/batchAdd',
      '/purchase/purchaseShare/modify',
    ];

    if (
      utils.getDataType(response.data) !== 'Blob' &&
      response.data.code &&
      response.config.url !==
        '/standard/evaluation/evaluationApply/checkEvaluationApplyCondition'
    ) {
      const codeArr = ['200', 'SAME_IP_ADDRESS'];
      if (!codeArr.includes(String(response.data.code))) {
        Message.closeAll();

        if (urlArr.includes(response.config.url)) {
          Message({
            message: response.data.message
              ? response.data.message
              : '服务器异常错误！',
            type: 'error',
            duration: 10000, // 10秒后自动关闭
          });
        } else {
          Message({
            message: response.data.message
              ? response.data.message
              : '服务器异常错误！',
            type: 'error',
          });
        }
      }
    }
    return response;
  },
  (err) => {
    // 每次手动关闭所有弹框
    Message.closeAll();
    if (err.response.status == 401) {
      // Message({
      //   message: "抱歉，你没有访问权限",
      //   type: "error",
      // });
      router.push({ path: '/ssologin' });
    }
    if (err.response.status == 403) {
      Message({
        message: '您没有权限访问该页面，请联系管理员分配权限',
        type: 'error',
      });
      if (!record403) {
        router.push({ path: '/403' });
      }
      // alert(record403)
      record403 = true;
      // router.push({ path: '/403' });
    }
    return Promise.resolve(err.response);
  }
);
const request = {
  /**
   * 封装get方法
   * @param url
   * @param data
   * @returns {Promise}
   */
  fetch(url, params = {}, config = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          // qmJson: JSON.stringify(params)
          params,
          ...config,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  /**
   * 封装post请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  post(url, data = {}, otherConfig = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, { ...otherConfig })
        // axios.post(url, Qs.stringify(data))
        .then(
          (response) => {
            resolve(response.data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  },
  // 获取基础地址
  getBaseUrl() {
    return axios.defaults.baseURL;
  },
};
export default request;
